import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

interface Data {
  current_page: number;
  data: any[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: string[];
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;
}

// This is redeclared until in figure out how to import it from react-query
interface UseGetAllResponse {
  isLoading: boolean;
  isError: boolean;
  error: any,
  data: Data,
  isFetching: boolean;
  isPreviousData: boolean;
  isPending: boolean;
  isLoadingError: boolean;
  isRefetchError: boolean;
  isSuccess: boolean;
  status: any;// enum?
}

// This uses defaultQueryFn from main.tsx
export function useGetAll(queryParams, params:any = null): UseGetAllResponse {
  const defaultQueryFn = async ({ queryKey/*, page = 1, include = 'default'*/ }) => {
      // console.log(queryKey);
      const urlParams = new URLSearchParams({
        // page: page.toString(),
        include: 'default',
        page: 1,
        ...params,
      });
      // console.log(params.toString());
      const { data } = await authenticatedApi.get(`/${queryKey[0]}?${urlParams}`).catch(e => console.error(e));
      // console.log(data);

      return data;//.hasOwnProperty('data') ? data.data : data;
  };

  // factor in other params
  if(params) {
    queryParams.queryKey.push(...Object.values(params));
    // console.log(Object.keys(params));
    // console.log(params);
    // console.log("useGetAll key", queryParams.queryKey);
    if(params.hasOwnProperty('for_search')) {
      queryParams.queryKey = [`searchselect_${queryParams.queryKey[0]}`]
    }
  }



    return useQuery({
        queryFn: defaultQueryFn,
        ...queryParams,
        // ...params
    });
}


/*

const {
        // isPending,
        isLoading,
        isError,
        error,
        data,
        isFetching,
        isPreviousData,
    } = useGetAllEcDevStats();


    current_page
    data
    first_page_url
    from
    last_page
    last_page_url
    links
    next_page_url
    path
    per_page
    prev_page_url
    to
    total


*/
